import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import moment from 'moment';
import { requestJobHistoryReport, clearJobHistoryReport } from '../../../../../shared/actionCreators/reports';
import { handleDateSave } from '../../../../../utils/dateUtils.js';
import PageActionBar from 'components/PageActionBar';
import AssigneeSelect from 'components/formElements/AssigneeSelect';
import DatePicker from 'components/DatePicker';
import ColoredButton from 'components/ColoredButton';
import Loading from 'components/Loading';
import Validator from 'mixins/validator';
import SimpleRequest from 'mixins/simple_request';
import JobHistoryTable from 'JobHistoryTable';
import contentAreaStyles from 'styles/contentArea';
import S from 'styles.scss';

class JobHistoryReport extends Validator(SimpleRequest(React.Component, 'JobHistoryReport')) {
  static VALIDATIONS = { installer_id: true }

  constructor(props) {
    super(props);
    const query = this.props.location.query;
    this.state = {
      installer_id: query.installer_id || null,
      start_date: moment(query.start_date).format('MM/DD/YYYY') || moment().format('YYYY-MM-DD'),
      errors: {},
    };
  }

  onStartDateChange = date => this.setState({ start_date: date });

  onInstallerChange = val => this.setState({ installer_id: val.employable_id || null });

  submit = (e) => {
    e.preventDefault();
    if (!this.validate()) { return; }
    const { installer_id, start_date } = this.state;
    const query = {
      installer_id: parseInt(installer_id, 10),
      start_date: handleDateSave(moment(start_date, 'MM/DD/YYYY')),
    };
    this.props.push({ pathname: this.props.location.pathname, query });
  }

  render = () => {
    const { report: { loaded, loading, data } } = this.props;
    const { start_date, errors } = this.state;
    return (<div>
      <PageActionBar
        showAdd={false}
        showFiltersBtn={false}
        title="Job History Report"
      />
      <div className={contentAreaStyles.contentAreaContainer}>
        <div className={`${contentAreaStyles.contentArea} ${S.noPrint}`}>
          <form onSubmit={this.submit} className={S.form}>
            <AssigneeSelect
              multi={false}
              className={S.formElement}
              onChange={this.onInstallerChange}
              placeholder="All Installers"
              installerOnly
            />
            <DatePicker
              className={S.formElement}
              label="Start Date"
              value={start_date}
              onChange={this.onStartDateChange}
              placeholder="Select Start Date"
              error={errors.start_date && errors.start_date.join(', ')}
              required
            />
            {this.props.children}
            <ColoredButton type="submit" className={S.formSubmit}>Run Report</ColoredButton>
          </form>
        </div>
        {loaded && (<div className={`${contentAreaStyles.contentArea} ${S.tableContainer}`}>
          <JobHistoryTable crews={data} />
        </div>)}
        {loading && <Loading />}
      </div>
    </div>);
  }
}

JobHistoryReport.propTypes = {
  location: PropTypes.shape({
    query: PropTypes.objectOf(PropTypes.string).isRequired,
    search: PropTypes.string.isRequired,
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  report: PropTypes.shape({
    loaded: PropTypes.bool,
  }),
  requestJobHistoryReport: PropTypes.func.isRequired,
  clearJobHistoryReport: PropTypes.func.isRequired,
};

export default connect(state => ({
  report: state.reports.jobHistory,
}), { requestJobHistoryReport, clearJobHistoryReport, push })(JobHistoryReport);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/reports/jobHistory/index.jsx